import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { SitecorePopularBetsConfig } from '@frontend/sports/common/client-config-data-access';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { TimerModule } from '../../../timers/timer.module';
import { PodEventsModel } from '../../popular-bets.models';

@Component({
    selector: 'ms-popular-bets-pod-header',
    templateUrl: './popular-bets-pod-header.component.html',
    styleUrl: './popular-bets-pod-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TimerModule, IconCustomComponent],
})
export class PopularBetsPodHeaderComponent {
    isEpcotEnabled = input.required<boolean>();
    pod = input.required<PodEventsModel>();

    constructor(public sitecorePopularBetsConfig: SitecorePopularBetsConfig) {}

    podHeaderTitle = computed(() => this.getPodHeaderTitle());

    private getPodHeaderTitle(): string | undefined {
        const podTitle = this.pod().title;

        if (podTitle && podTitle?.trim() !== '') {
            return podTitle.trim();
        }

        const competitionName = this.getCommonCompetitionName();
        if (competitionName) {
            return competitionName;
        }

        return this.pod().sport?.name;
    }

    private getCommonCompetitionName(): string | undefined {
        const events = this.pod().events;

        if (events?.length) {
            const firstCompetitionId = events[0].league.id;
            const hasOnlyOneCompetitionId = events.every((event) => event.league.id === firstCompetitionId);
            if (hasOnlyOneCompetitionId) {
                return events[0].league.name;
            }
        }

        return undefined;
    }
}
